import React from "react";
import type { TitleOrder } from "@mantine/core";
import PageHeader from "../../common/PageHeader/PageHeader";

export interface SettingsPageHeaderProps {
  /** Page title. */
  title: React.ReactNode;
  /** One-line description under the title. */
  subtitle?: React.ReactNode;
  /** Right-aligned controls (primary button, icon menus, etc.). */
  actions?: React.ReactNode;
  /** Slot above the title row (e.g. a back link / breadcrumb). */
  above?: React.ReactNode;
  /** Heading order. The settings standard is 3. */
  titleOrder?: TitleOrder;
}

/**
 * Settings page header: the app-wide {@link PageHeader} with the settings
 * default title order (3). Consolidates the ~15 hand-rolled per-page
 * title/subtitle/actions rows into one on-pattern header.
 */
export default function SettingsPageHeader({
  title,
  subtitle,
  actions,
  above,
  titleOrder = 3,
}: SettingsPageHeaderProps) {
  return (
    <PageHeader
      title={title}
      subtitle={subtitle}
      actions={actions}
      above={above}
      titleOrder={titleOrder}
    />
  );
}
